/* eslint-disable no-param-reassign */
/* eslint-disable default-case */
/* eslint-disable @typescript-eslint/no-unsafe-call */
// @ts-nocheck
// import * as HXKlineChart from '@ths-m/HXKlineChart';
// import * as HXKline from '@ths-m/HXKline';
import { type Layer, type HXKLineLayerSpec, defineHXKLineLayer } from '../../../core/layer';
import type { StockData, KLineData } from '../helper/hxKLine';
import type { KLineTooltipItem } from '../ui/kLineTooltip/KLineTooltip';

HXKline.setHXKlineChart(HXKlineChart);

const visInfo: Layer['visInfo'] = {
  id: 'hxKLine',
  name_en: 'Candlestick Chart',
  name_zh: '行情图',
  types_en: [],
  purpose_en: [],
  purpose_zh: [],
  standers: '',
  parameters: {},
  extra: {
    isNotTrainedByLLM: true
  }
};

export interface Spec extends HXKLineLayerSpec {
  stocks: StockData[];
}

type Stock = {
  id: string;
  code: string;
  market: string;
  name: string;
  data_class?: string;
  time_period?: string;
  trade_date?: number;
  adjust_type?: string;
  trade_class: string;
};

const STOCK_TYPE = {
  TREND: 'trend',
  KLINE: 'kline'
};

function getTooltipData(tooltipArray: string[], layout: string, LAYOUT) {
  let showTooltip;
  if (layout === LAYOUT.SMALL || layout === LAYOUT.SMALL_1_2) {
    // 设计师规定，卡片宽度较小时只显示两项tooltip字段
    showTooltip = tooltipArray.slice(0, 3);
  } else {
    // 其他情况下展示全量字段
    showTooltip = tooltipArray;
  }
  return showTooltip;
}

export const layer = defineHXKLineLayer<Spec>({
  type: visInfo.id,
  isIndependentLayer: true,
  visInfo,
  // eslint-disable-next-line max-lines-per-function, sonarjs/cognitive-complexity
  render(api, spec, $dom) {
    const { layout, hook: hooks, util: utils, ui, token } = api;
    let scrollButtonGroupIns: InstanceType<(typeof ui)['ScrollButtonGroup']>;
    let chartIns: { dispose: (ds: string, callback: (data: any) => void) => void };
    let buttonGroupIns: InstanceType<(typeof ui)['ButtonGroup']>;
    let kLineTooltipIns: InstanceType<(typeof ui)['KLineTooltip']>;

    HXKline.verifyProjectPermission(hooks.globalConfig(api).hxKLineVerifyInfo);

    // * -------------------------- dom
    const $tooltipContainer = document.createElement('div');
    const $scrollButtonGroup = document.createElement('section');
    const $ButtonGroup = document.createElement('section');
    const $indicatorTooltip = document.createElement('div');
    const $chart = document.createElement('section');
    const lineColor = token?.dvHXKLine?.constants?.DEFAULT_TICK_LINE_COLOR;
    const borderLineStyle = `1px solid ${lineColor || 'rgba(125, 133, 146, 0.3)'}`;

    $dom.style.cssText +=
      'display: flex; flex-direction: column; justify-content: center; align-items: center;';

    $scrollButtonGroup.style.cssText = 'width: 100%; margin-bottom: 8px;';
    $ButtonGroup.style.cssText =
      'width: 100%; height: 22px; display: flex; margin-bottom: 8px; flex-direction: row;';
    $indicatorTooltip.style.cssText =
      'color: #60656C; font-size: 12px; font-weight: 400; line-height: 12px; margin-left: 4px; margin-top: 4px; font-family: Microsoft YaHei;';
    $chart.style.cssText = 'flex: 1; height: 0; width: 100%;';

    $dom.appendChild($scrollButtonGroup);
    $dom.appendChild($ButtonGroup);
    $dom.appendChild($tooltipContainer);
    $dom.appendChild($chart);

    // * -------------------------- data
    const { stocks } = spec;
    const stockIndex = 0;
    const buttonNameMap = {
      分时: 'trend',
      日线: 'day_1',
      周线: 'week_1',
      月线: 'month_1'
    };
    let stockType: string = Object.values(buttonNameMap)[stockIndex];
    const stocksName: string[] = stocks.map(stock => stock.name);
    const generateStockInfo = () =>
      ({
        id: utils.common.generateUID(),
        code: stocks[stockIndex].code,
        market: stocks[stockIndex].market,
        name: stocks[stockIndex].name,
        data_class: STOCK_TYPE.TREND,
        trade_class: 'intraday',
        trade_date: 0
      }) as Stock;
    let stockInfo: Stock = generateStockInfo();

    // * -------------------------- headButton
    scrollButtonGroupIns = new ui.ScrollButtonGroup($scrollButtonGroup, {
      buttonArray: stocksName,
      data: stocks.map((value, key) => {
        return {
          key,
          value
        };
      }),
      token: token.dvScrollButtonGroup
    });
    if (stocksName.length <= 1) {
      $scrollButtonGroup.style.cssText = 'display: none;';
    }

    // * -------------------------- buttonGroup
    buttonGroupIns = new ui.ButtonGroup($ButtonGroup, {
      buttonArray: Object.keys(buttonNameMap),
      data: Object.values(buttonNameMap).map((value, key) => {
        return {
          key,
          value
        };
      }),
      token: token.dvButtonGroup
    });

    // * -------------------------- kLineTooltipIns
    kLineTooltipIns = new ui.KLineTooltip($tooltipContainer, {
      token
    });

    // * -------------------------- showTooltip
    function showKLineTooltip(kline: unknown, dataIndex?: number | undefined) {
      // 获取k线的默认tooltip数据和k线原始数据
      const {
        defaultTooltipData: defaultKLineTooltip,
        kLineData
      }: { defaultTooltipData: KLineTooltipItem[]; kLineData: KLineData } =
        hooks.getHXKLineTooltipData(kline, 'kline', dataIndex);

      // 获取分时的默认tooltip数据
      const {
        defaultTooltipData: defaultTrendTooltip
      }: { defaultTooltipData: KLineTooltipItem[] } = hooks.getHXKLineTooltipData(
        kline,
        'trend',
        dataIndex
      );

      // 根据卡片大小和行情图种类确定tooltip的展示数目
      const { LAYOUT }: { LAYOUT: (typeof utils)['const']['LAYOUT'] } = utils.const;
      let showTooltip;
      if (stockType !== STOCK_TYPE.TREND) {
        showTooltip = getTooltipData(defaultKLineTooltip, layout, LAYOUT);
      } else {
        showTooltip = getTooltipData(defaultTrendTooltip, layout, LAYOUT);
      }
      kLineTooltipIns.show(showTooltip);

      return kLineData;
    }

    // * -------------------------- chart
    // eslint-disable-next-line max-lines-per-function
    function chartInit(dom: HTMLElement, newStockInfo: Stock) {
      if (chartIns) {
        HXKline.disposeChart($chart, (...args) => {
          console.log('hxKLine destroy', ...args);
        });
      }

      const UNIT = {
        万: 10000,
        亿: 100000000
      };

      const formatBigNumber = value => {
        let result: string | number = Number(value).toFixed(2);
        Object.keys(UNIT).forEach(name => {
          if (value > +UNIT[name]) {
            result = `${(value / +UNIT[name]).toFixed(2)}${name}`;
          }
        });

        return result;
      };

      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const kline = HXKline.initChart(
        dom,
        newStockInfo,
        /**
         * @see https://khtest.10jqka.com.cn/kodexplorer/data/User/wangyifan/home/HXKlineChart/docs/guide/chart-api.html
         */
        {
          locale: 'zh_CN',
          customApi: {
            formatBigNumber
          },
          styles: 'customTheme'
        },
        (...args) => {
          if (args[0] === 'success') {
            kline.setZoomEnabled(false);
            kline.setScrollEnabled(false);
            kline.setBarSpaceLimit({ min: 0, max: 50 });
            kline.zoomToShowAllData();

            if (token?.dvHXKLine?.hxKLine?.option) {
              kline.setStyles(token?.dvHXKLine?.hxKLine?.option);
            }

            // 处理 dom 相关的问题
            const $main = dom.querySelector('div > div > div:nth-child(1)') as HTMLElement;
            const $indicator = dom.querySelector(
              'div > div:nth-child(3) > div:nth-child(1)'
            ) as HTMLElement;
            const $indicatorXAxis = $chart.querySelector(
              'div > div:nth-child(4) > div:nth-child(1)'
            ) as HTMLElement;
            const $candleYAxis = $chart.querySelector(
              'div > div > div:nth-child(2)'
            ) as HTMLElement;
            const $indicatorYAxis = $chart.querySelector(
              'div > div:nth-child(3) > div:nth-child(2)'
            ) as HTMLElement;
            $indicatorXAxis.style.cursor = 'default';
            $candleYAxis.style.cursor = 'default';
            $indicatorYAxis.style.cursor = 'default';
            if ($main) {
              $main.style.borderTop = borderLineStyle;
              $main.style[newStockInfo.data_class === 'kline' ? 'borderLeft' : 'borderRight'] =
                borderLineStyle;
            }
            if ($indicator) {
              $indicator.style[newStockInfo.data_class === 'kline' ? 'borderLeft' : 'borderRight'] =
                borderLineStyle;
            }

            // 初始tooltip展示最近日期的数据
            showKLineTooltip(kline);

            /**
             * - gap 限制主图内容的上下间隔
             * - scrollZoomEnabled 限制y轴的拖动
             */
            kline.setPaneOptions({
              id: 'candle_pane',
              gap: {
                top: 0.05,
                bottom: 0.05
              },
              axisOptions: { scrollZoomEnabled: false }
            });
          }
        }
      );

      const volumeId = kline.createIndicator(
        {
          name: 'VOL',
          shouldFormatBigNumber: true,
          precision: 1
        },
        true,
        {}
      );

      // 创建一个副图技术指标VOL(清除副图的均线)
      kline.overrideIndicator(
        {
          name: 'VOL',
          shortName: '成交量',
          calcParams: [],
          precision: 2,
          figures: [
            {
              key: 'volume',
              title: '成交量: ',
              type: 'bar',
              baseValue: 0
            }
          ]
        },
        volumeId
      );

      // 设置副图tooltip高度
      const domHeight = (+$chart.offsetHeight * 1) / 4;
      kline.setPaneOptions({
        id: volumeId,
        height: Math.floor(domHeight),
        dragEnabled: false,
        gap: { top: 24, bottom: 0 },
        axisOptions: { scrollZoomEnabled: false }
      });

      /** 副图容器 */
      const indicatorDom = kline.getDom(volumeId, 'main');

      /**
       * 监听图表的十字交叉数据变化，并获取数据
       */
      kline.subscribeAction('onCrosshairChange', (...args) => {
        const kLineData = showKLineTooltip(kline, args[0].dataIndex);
        // 设置副图的tooltip
        function setIndicatorTooltip() {
          if (!args[0].indicatorData[volumeId].VOL) {
            return;
          }
          const { volume } = args[0].indicatorData[volumeId].VOL;
          let volumeColor;
          const color = utils.const.HXKLINE_COLOR;
          const [black, red, green] = color;
          if (kLineData.close > kLineData.open) {
            volumeColor = red;
          } else if (kLineData.close < kLineData.open) {
            volumeColor = green;
          } else {
            volumeColor = black;
          }
          $indicatorTooltip.innerHTML = `<span style='color: '>成交量：</span><span style='color: ${volumeColor}'>${volume}</span>`;
          indicatorDom.insertBefore($indicatorTooltip, indicatorDom.firstChild);
        }
        setIndicatorTooltip();
      });

      return kline as unknown;
    }

    $chart.addEventListener('mouseleave', () => {
      $indicatorTooltip.innerHTML = '';
      showKLineTooltip(chartIns);
    });

    scrollButtonGroupIns.on('change', e => {
      stockInfo = {
        ...generateStockInfo(),
        ...e.value
      } as Stock;
      chartIns = chartInit($chart, stockInfo);
      buttonGroupIns.init();
      showKLineTooltip(chartIns);
    });

    buttonGroupIns.on('change', e => {
      stockType = e.value;

      if (!e.key) {
        stockInfo = {
          id: utils.common.generateUID(),
          code: stockInfo.code,
          market: stockInfo.market,
          name: stockInfo.name,
          data_class: stockType,
          trade_class: 'intraday',
          trade_date: 0
        };
      } else {
        stockInfo = {
          id: utils.common.generateUID(),
          code: stockInfo.code,
          market: stockInfo.market,
          name: stockInfo.name,
          data_class: 'kline',
          time_period: stockType,
          trade_date: 0,
          adjust_type: 'forward'
        };
      }
      chartIns = chartInit($chart, stockInfo);
    });

    chartIns = chartInit($chart, stockInfo);

    return () => {
      scrollButtonGroupIns?.destroy?.();
      buttonGroupIns?.destroy?.();
      kLineTooltipIns?.destroy?.();
      HXKline.disposeChart($chart, (...args) => {
        console.log('hxKLine destroy', ...args);
      });

      $dom.innerHTML = '';
    };
  }
});
